import { Box, Typography } from "@mui/material";

interface SummaryMetricProps {
  label: string;
  value: string | number;
}

export function SummaryMetric({ label, value }: SummaryMetricProps) {
  return (
    <Box>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mb: 0.5, fontWeight: 500 }}
      >
        {label}
      </Typography>
      <Typography variant="h6" fontWeight={600}>
        {value}
      </Typography>
    </Box>
  );
}
